module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Article-126771bb110e54585ff8bf6da452fd2d477f552529c9864e43da868b52291618.svg";